
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'HDSS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/HDSS.vue